import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";

import './RegistrationFailedPopUp.style.scss';
import {FormattedMessage} from "react-intl";
import {useSelector} from "react-redux";
import {selectUserRegistrationError} from "../../../stores/account/account.selectors";
const RegistrationFailedPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options}) => {
    const userRegistrationError = useSelector(selectUserRegistrationError);

    return (
        <Dialog open={open} onClose={onClose} className="RegistrationFailedPopUp">
            <DialogContent className="RegistrationFailedContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title">
                    <FormattedMessage id={'popUp.registrationFailed.title'}/>
                </Typography>
                <Typography className="subTitle">
                    {userRegistrationError? userRegistrationError : <FormattedMessage id={'popUp.registrationFailed.subTitle'}/>}
                </Typography>

                <div className={'actionButton'}>
                    <Button className="login" onClick={() => {
                        onOk()
                    }}>
                        <FormattedMessage id={'popUp.registrationFailed.tryAgain'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default RegistrationFailedPopUp;
